import BaseAPI from "../api";

const path: string = "interview-student";

export class InterviewStudentApi extends BaseAPI {
  static createInterviewStudent(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getInterviewStudentById(id_interview_student: any): Promise<any> {
    return this.api.get(`${path}/admission_student/${id_interview_student}`);
  }

  static getInterviewStudentList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static resultInterview(body: any): Promise<any> {
    return this.api.post(`${path}/result-interview`, body);
  }
}